import { Box, IconButton, TextareaAutosize, Typography } from '@mui/material'
import { url } from 'inspector'
import React, { useEffect, useRef, useState } from 'react'
import chatbackground from '../../assets/images/chatgabackground.png'
import { SendOutlined } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { ApiGetAnalytics } from '../../apiService/Core/Apicall'
import { showLoading } from '../../global/config/Reducer/loadingSlice'
import storage from '../../utils/storage'

function InsightBot() {
    const [message, setMessage] = useState("")
    const [chat, setchat] = useState<any[]>([])
    const [isShowloading, setShowloading] = useState<boolean>(false)
    const clientEntityId = storage.getItem('clientEntityId')
    const chatContainerRef = useRef<HTMLDivElement | null>(null);

    const handleSendChat = async () => {
        if (!message) {
            return
        }
        setShowloading(true)
        try {
            const data = {
                question: message,
                clientEntityId
            }
            setchat((prev: any) => [
                ...prev,
                {
                    from: "Client",
                    message: message,
                    time: new Date().toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                    }),
                },
            ]);
            setMessage("")

            const res = await ApiGetAnalytics(data)
            if (res.status) {
                setchat((prev: any) => [
                    ...prev,
                    {
                        from: "Server",
                        message: res?.answer,
                        time: new Date().toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        }),
                    },
                ]);
            }


        } catch (error: any) {
            toast.error(error?.message)
        }
        finally {
            setShowloading(false)
        }
    }
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
        }
    }, [chat, isShowloading]);
    return (
        <Box className='w-100 d-flex flex-column px-2 pt-1' gap={1} height='calc(100vh - 100px)' sx={{ background: `url(${chatbackground})` }}>
            <Box className='d-flex justify-content-end flex-column' overflow={'hidden'} flex={1}>
                <Box ref={chatContainerRef}
                    className='d-flex flex-column mt-auto' maxHeight={'100%'} gap={2} overflow={'auto'}>
                    {chat?.map((item, index) => (
                        <Box
                            key={index}
                            className='w-100'
                            display="flex"
                            justifyContent={item?.from === "Client" ? "flex-end" : "flex-start"}
                        >
                            <Box
                                borderRadius="10px"
                                className={`${item?.from == "Client" ? "bg-main text-white" : "bg-secondary text-white fw-bold"} p-2 pb-0 }`}
                                sx={{
                                    maxWidth: "70%",
                                }}
                            >
                                <Typography className='pe-4 mb-1'>{item?.message}</Typography>
                                <Box className='d-flex flex-column w-100'>
                                    <Typography variant='caption' className='text-end'>{item?.time}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                    {isShowloading && (
                        <Box
                            className="w-100"
                            display="flex"
                            justifyContent="flex-start"
                        >
                            <Box
                                borderRadius="8px"
                                className="bg-secondary"
                                sx={{
                                    maxWidth: "70%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    padding: '14px 20px'
                                }}
                            >
                                {[0, 1, 2].map((dot) => (
                                    <Box
                                        key={dot}
                                        sx={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: "50%",
                                            backgroundColor: "#FFFFFF",
                                            animation: "bounce 1.4s infinite ease-in-out",
                                            animationDelay: `${dot * 0.2}s`,
                                            "@keyframes bounce": {
                                                "0%, 80%, 100%": {
                                                    transform: "scale(0)",
                                                },
                                                "40%": {
                                                    transform: "scale(1)",
                                                },
                                            },
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box className='d-flex align-items-center' gap={1}>
                <TextareaAutosize className='w-100 mt-auto custom-textarea p-1 px-2' value={message} onChange={(e) => { setMessage(e.target.value) }} minRows={2} placeholder='Explain what you’re looking for…' autoFocus style={{}} />
                <IconButton onClick={handleSendChat} sx={{
                    backgroundColor: "var(--secondary-color)",
                    "&:hover": {
                        backgroundColor: "var(--secondary-color)", // same color
                    },
                }}><SendOutlined className='m-1' sx={{ color: 'white' }} /></IconButton>
            </Box>
        </Box>
    )
}

export default InsightBot
